import { Flex, FlexProps } from '@chakra-ui/react'
import { useEffect, useState } from 'react'

export const BurgerMenu = ({
  isOpen,
  onToggle,
  size,
  barHeight = 2,
  ...props
}: {
  isOpen: boolean
  onToggle: () => void
  size: number
  barHeight?: number
} & FlexProps) => {
  const [displayMiddleBar, setDisplayMiddleBar] = useState('1')
  const [rotationTop, setRotationTop] = useState(0)
  const [rotationBottom, setRotationBottom] = useState(0)
  const [topY, setTopY] = useState(-10)
  const [bottomY, setBottomY] = useState(10)

  useEffect(() => {
    if (isOpen) {
      setDisplayMiddleBar('0')
      setRotationTop(45)
      setRotationBottom(-45)
      setTopY(0)
      setBottomY(0)
    } else {
      setDisplayMiddleBar('1')
      setRotationTop(0)
      setRotationBottom(0)
      setTopY(-10)
      setBottomY(10)
    }
  }, [isOpen])

  return (
    <Flex
      position="relative"
      justify="center"
      align="center"
      w={`${size}px`}
      h={`${size}px`}
      onClick={onToggle}
      cursor="pointer"
      {...props}
    >
      {/* Top bar */}
      <Flex
        position="absolute"
        w="80%"
        h={`${barHeight}px`}
        bg="black"
        transform={`translateY(${topY}px) rotate(${rotationTop}deg)`}
        transformOrigin="center"
        transition="transform 0.4s ease"
      />

      {/* Middle bar */}
      <Flex
        position="absolute"
        w="80%"
        h={`${barHeight}px`}
        bg="black"
        opacity={displayMiddleBar}
        transition="opacity 0.4s ease"
      />

      {/* Bottom bar */}
      <Flex
        position="absolute"
        w="80%"
        h={`${barHeight}px`}
        bg="black"
        transform={`translateY(${bottomY}px) rotate(${rotationBottom}deg)`}
        transformOrigin="center"
        transition="transform 0.4s ease"
      />
    </Flex>
  )
}
